import {
  Avatar,
  IconButton,
  Popover,
  Stack,
  SxProps,
  Typography,
} from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import {
  BlueRequest,
  MessengerAppIcon,
  PurpleFillShareMedia,
  PurpleIcon,
  ShareMediaPurple,
  WhatsAppIcon,
} from 'Images';
import { useState } from 'react';

export const Share = () => {
  const [isMediaPopoverOpen, setIsMediaPopoverOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<Element | null>(null);

  const isDesktop = useIsDesktop();

  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage
    .therapy;

  const openMediaPopoverHandler = (event: React.MouseEvent) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget as Element);
    setIsMediaPopoverOpen(!isMediaPopoverOpen);
  };

  const mediaStackSx: SxProps = {
    flexFlow: 'row',
    alignItems: 'center',
    gap: '8px',
    whiteSpace: 'nowrap',
    p: '8px 24px 8px 16px',

    ':hover': {
      cursor: 'pointer',
      bgcolor: 'purple2.shade_100',
    },
  };

  const mediaIconSx: SxProps = {
    width: '20px',
    height: '20px',
  };

  return (
    <IconButton
      onClick={openMediaPopoverHandler}
      sx={{
        p: 0,
        ':hover': {
          outline: '1px solid #A020FF',
        },
      }}
    >
      <Avatar
        alt=''
        src={isMediaPopoverOpen ? PurpleFillShareMedia : ShareMediaPurple}
        sx={
          isDesktop
            ? { width: '32px', height: '32px' }
            : { width: '26px', height: '26px' }
        }
      />
      <Popover
        open={isMediaPopoverOpen}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: {
            display: 'flex',
            flexFlow: 'column',
            mt: isDesktop ? '7px' : '3px',
            boxShadow: 'none',
            border: '1px solid #A020FF',
          },
        }}
      >
        <Stack sx={{ ...mediaStackSx }}>
          <Avatar alt='' src={PurpleIcon} sx={{ ...mediaIconSx }} />
          <Typography variant='body6'>{dictionary.copy}</Typography>
        </Stack>
        <Stack sx={{ ...mediaStackSx }}>
          <Avatar alt='' src={BlueRequest} sx={{ ...mediaIconSx }} />
          <Typography variant='body6'>{dictionary.mailShare}</Typography>
        </Stack>
        <Stack sx={{ ...mediaStackSx }}>
          <Avatar alt='' src={WhatsAppIcon} sx={{ ...mediaIconSx }} />
          <Typography variant='body6'>{dictionary.whatsAppShare}</Typography>
        </Stack>
        <Stack sx={{ ...mediaStackSx }}>
          <Avatar alt='' src={MessengerAppIcon} sx={{ ...mediaIconSx }} />
          <Typography variant='body6'>{dictionary.MsnAppShare}</Typography>
        </Stack>
      </Popover>
    </IconButton>
  );
};
